module.exports = __webpack_public_path__ + "static/media/bars.7dff4796.svg";